export default __webpack_public_path__ + "static/media/BookAppointment.36eec356.svg";